module.exports = __webpack_public_path__ + "img/top_bg.ba384c5.png";